import React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/Typography/Typography";
import Rating from "@material-ui/lab/Rating/Rating";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from "@material-ui/core/Button/Button";
import { useHistory, useLocation } from "react-router-dom"
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginBottom: 0,
            borderRadius:0,
            wborderBottom: '1px solid #ccc',
            border: 'none',
        },
        content: {
            paddingBottom: 0,
            '&:last-child': {
                paddingBottom: 0
            }
        },
        about: {
            fontSize: '0.9rem'
        },
        comment: {
            fontSize: '0.8rem'
        },
        name: {
            fontSize: '0.8rem',
            alignItems: 'right',
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        link: {
            marginLeft: 10
        },
        progress: {
            marginLeft: 80,
            marginTop: 20,
            marginBottom: 20,
        }

    }});

export default function ColumnReviewsList(props) {

    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const reviews = props.reviews;

    const displayTitle = props.displayTitle;

    const handleClick = (e) => {
        e.preventDefault();
        props.setReturnToItemRoute(window.location.pathname);
        history.push(reviews.url);
        return false;
    };

    const handleSubmitReview = () => {
        props.handleSubmitReview();
    };

    const displayMax = 155;

    return (
        <div className={classes.block}>
            {!reviews ? <CircularProgress className={classes.progress} size={20}/> : null}
            {reviews && !reviews.items.length ?

                <Card className={classes.root} variant="outlined">
                    <CardContent className={classes.content}>
                        <Typography color="textSecondary" className={classes.about}>
                            {displayTitle}
                        </Typography>
                        <Rating name="customized-10" defaultValue={5} precision={0.5} max={5} size="small" readOnly/>
                        <Typography variant="body2" component="p" className={classes.comment}>
                            {props.noReviewsMessage}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" onClick={handleSubmitReview}>Submit Review</Button>
                    </CardActions>
                </Card>

                : ''}
            {reviews && reviews.items.map((item, index) => {

                const shortText = item.description && item.description.length > displayMax
                    ?  item.description.substr(0, displayMax) + '...' : item.description;
                return <Card className={classes.root} variant="outlined">
                    <CardContent className={classes.content}>
                        <Rating name="customized-10" defaultValue={item.rating} precision={0.5} max={5} size="small" readOnly/>
                        <Typography variant="body2" component="p" className={classes.comment}>
                            {shortText ? '"'+shortText+'" - ' : ''}{item.name}
                        </Typography>
                    </CardContent>
                    {index === reviews.items.length - 1 ? <CardActions>
                        <a href={reviews.url} onClick={handleClick} className={classes.link}>
                            <Typography>All Reviews</Typography></a>
                    </CardActions> : ''}
                </Card>
            })}
        </div>
    );
}
